var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.map[_vm.$query.tag])?_c('img',{directives:[{name:"img-pop",rawName:"v-img-pop",value:({name: _vm.$query.tag}),expression:"{name: $query.tag}"}],attrs:{"src":_vm.map[_vm.$query.tag]}}):_c('div',[_vm._v("(敬请期待)")])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-073afd0e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ComingSoon.vue
// module id = null
// module chunks = 